"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusManager = exports.default = void 0;
var _react = require("react");
var _focusManager = require("./focusManager");
const useFocusManager = (managerProps, shouldAttach, ref) => {
  const [focusManager, setFocusManager] = (0, _react.useState)(null);
  const attachFocusManager = () => {
    if ((ref === null || ref === void 0 ? void 0 : ref.current) && !focusManager) {
      setFocusManager(new _focusManager.FocusManager(Object.assign({
        trapNode: ref === null || ref === void 0 ? void 0 : ref.current
      }, managerProps)));
    }
  };
  (0, _react.useEffect)(() => {
    if (shouldAttach) {
      attachFocusManager();
    } else {
      focusManager === null || focusManager === void 0 ? void 0 : focusManager.detach();
      setFocusManager(null);
    }
    return () => {
      focusManager === null || focusManager === void 0 ? void 0 : focusManager.detach();
    };
  }, [shouldAttach, ref === null || ref === void 0 ? void 0 : ref.current]);
};
exports.useFocusManager = useFocusManager;
var _default = exports.default = useFocusManager;